import React from 'react';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import TableViewIcon from '@mui/icons-material/TableView';

const RemoveTableIcon = () => {
	return (
		<span
			style={{
				position: 'relative',
				display: 'inline-flex',
			}}
		>
			<TableViewIcon
				style={{
					display: 'block',
				}}
				size='small'
			/>
			<RemoveCircleIcon
				size='small'
				style={{
					position: 'absolute',
					top: 1,
					right: -2,
					backgroundColor: 'white',
					borderRadius: '50%',
					width: 10,
					height: 10,
					fontSize: '24px',
					pointerEvents: 'none',
				}}
			/>
		</span>
	);
};

export default RemoveTableIcon;
